import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import ReduxThunk from "redux-thunk"
import { createLogger } from 'redux-logger';
import state from './initialState';
import configureStore from './store/index.js';
import { Router, browserHistory } from 'react-router';
import routes from './routes';

let log = createLogger();
let middleware = [ReduxThunk];
middleware.push(log);   

const store = configureStore(state);

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory} routes={routes} />      
    </Provider>, 
document.querySelector(".app"));



// WEBPACK FOOTER //
// ./src/index.js